import Splide from "@splidejs/splide";

export const lineupModalSliders = () => {
  if (document.querySelector(".js-lineup-modal-main-slider") === null) {
    return;
  }

  const sliderGroups = document.querySelectorAll(".js-lineup-modal-slider-group");

  sliderGroups.forEach((sliderGroup) => {
    const mainSlider = sliderGroup.querySelector(".js-lineup-modal-main-slider");
    const thumbSlider = sliderGroup.querySelector(".js-lineup-modal-thumb-slider");

    const main = new Splide(mainSlider, {
      type: "fade",
      speed: 1000,
      rewind: true,
      pagination: false,
      arrows: false,
      lazyLoad: "nearby",
    });

    const thumb = new Splide(thumbSlider, {
      height: "100%",
      direction: "ttb",
      gap: "0.8rem",
      perPage: 5,
      rewind: true,
      speed: 1000,
      pagination: false,
      arrows: false,
      isNavigation: true,
      breakpoints: {
        768: {
          direction: "ltr",
          gap: "0.5rem",
        },
      },
    });

    main.sync(thumb);

    main.mount();
    thumb.mount();
  });
};
